<template>
  <DialogCard>
    <template #title>
      About
    </template>
    <template #text>
      <p>
        openVOXEL's mission: To assist researchers with the storage and<br>
        visualization of anatomical and functional data<br>
        from magnetic resonance imaging.
      </p>
      <p>
        openVOXEL's objectives: openVOXEL aims to give researchers control<br>
        over anatomical and functional data from magnetic resonance imaging.<br>
        By doing so, openVOXEL aims to do its part in improving magnetic<br>
        resonance imaging research, possibly advancing more accurate<br>
        interpretations from imaging data. openVOXEL thus strives to radically<br>
        boost research around magnetic resonance images, giving researchers<br>
        precise tools to derive new insights.<br>
      </p>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'OpenvoxelAboutDialog',
  components: {
    DialogCard,
  },
};
</script>
